"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionTableModalContentTabContent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
// import {useRetentionContext} from "src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionDataProvider";
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const retention_table_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/table/retention_table");
const RetentionTableService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/table/RetentionTableService");
const antd_1 = require("antd");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
require("./retention_table.less");
const RetentionTableModalContentTabContent = () => {
    var _a, _b;
    const [tableError, setTableError] = (0, react_1.useState)(undefined);
    const loaderRef = (0, react_1.useRef)();
    const currentComponentElementRef = (0, react_1.useRef)();
    // const retentionContext = useRetentionContext();
    // const retentionState: RetentionChartResultData | undefined = retentionContext.data?.retention
    const retentionContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const request = (_a = retentionContext.state.data) === null || _a === void 0 ? void 0 : _a.request;
    const retentionState = (_b = retentionContext.state.data) === null || _b === void 0 ? void 0 : _b.response;
    const destroyLoader = (0, react_1.useCallback)(() => {
        if (loaderRef.current && loaderRef.current.parentNode) {
            loaderRef.current.parentNode.removeChild(loaderRef.current);
        }
    }, [loaderRef]);
    const destroyTable = (0, react_1.useCallback)(() => {
        if (currentComponentElementRef.current) {
            currentComponentElementRef.current.innerHTML = "";
        }
    }, [currentComponentElementRef]);
    const drawTable = (0, react_1.useCallback)(() => {
        if (!request || !retentionState) {
            destroyLoader();
            return;
        }
        try {
            const container = currentComponentElementRef.current;
            const retentionAsNumbers = Array.from(retentionState.retention, v => Array.from(v));
            retention_table_1.RetentionTable.draw({
                type: "retention",
                repeatLevels: (0, RetentionTableService_1.getRepeatLevels)(retentionAsNumbers),
                initialDateMillis: retentionState.intervalStartTimeSec * 1000,
                container: container,
                cohort: retentionAsNumbers,
                retentionPeriods: Array.from(retentionState.retentionPeriods),
                cohortName: "Cohort",
                retentionType: CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(request.retentionType),
                cohortCheckEndDays: 0,
            });
            destroyLoader();
        }
        catch (e) {
            destroyLoader();
            destroyTable();
            setTableError(e);
        }
    }, [destroyLoader, destroyTable, currentComponentElementRef, JSON.stringify(retentionState)]);
    (0, react_1.useEffect)(() => {
        window.setTimeout(function () {
            drawTable();
            document.querySelectorAll(".retention-table-bottom-table").forEach(value => value.classList.add("active"));
        }, 200);
    }, [drawTable]);
    return React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("span", { ref: loaderRef, style: { width: "100%", padding: "50px", display: "inline-block" } },
                React.createElement(PageLoaderComponent_1.default, null)),
            tableError && React.createElement(antd_1.Result, { status: "error", icon: React.createElement(React.Fragment, null), title: "Oops, something went wrong", subTitle: React.createElement(React.Fragment, null,
                    "Table cannot be loaded.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("code", null, tableError.message)) }),
            React.createElement("div", { ref: currentComponentElementRef, className: "retentionTable" })));
};
exports.RetentionTableModalContentTabContent = RetentionTableModalContentTabContent;
